(function () {
  'use strict';
  var KEY = 'aquaphoria-experience-v1';
  var dialog = document.getElementById('aq-experience-choice');
  if (!dialog) return;
  var memoryChoice = null;
  var choice = null;
  try { choice = localStorage.getItem(KEY); } catch (e) {
    try { choice = sessionStorage.getItem(KEY); } catch (ignored) {}
  }
  function apply(mode) {
    document.documentElement.dataset.aqExperience = mode;
    document.querySelectorAll('[data-aquaphoria-v5-3d]').forEach(function (root) {
      root.dataset.experience = mode;
    });
    window.dispatchEvent(new CustomEvent('aquaphoria:experience-change', { detail: { mode: mode } }));
    if (window.aqExperiencePrevious && window.aqExperiencePrevious !== mode) {
      window.location.reload();
    }
    window.aqExperiencePrevious = mode;
  }
  function choose(mode) {
    memoryChoice = mode;
    try { localStorage.setItem(KEY, mode); } catch (e) {
      try { sessionStorage.setItem(KEY, mode); } catch (ignored) {}
    }
    apply(mode);
    dialog.hidden = true;
    document.body.classList.remove('aq-experience-open');
    var opener = document.getElementById('aq-experience-switch');
    if (opener) opener.focus();
  }
  var hasSavedChoice = choice === 'simple' || choice === 'immersive';
  var isHomePage = window.location.pathname === '/';
  // Buyer-first default: never block the storefront on first arrival.
  // Visitors can still open the experience picker using Switch Experience.
  if (!hasSavedChoice) choice = 'simple';
  apply(choice);
  dialog.addEventListener('click', function (event) {
    var button = event.target.closest('[data-aq-choice]');
    if (button) choose(button.dataset.aqChoice);
  });
  var switcher = document.getElementById('aq-experience-switch');
  if (switcher && !isHomePage) switcher.style.display = 'none';
  if (switcher) switcher.addEventListener('click', function () {
    dialog.hidden = false;
    document.body.classList.add('aq-experience-open');
    var first = dialog.querySelector('[data-aq-choice]');
    if (first) first.focus();
  });
  dialog.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { event.preventDefault(); choose('simple'); }
    if (event.key !== 'Tab') return;
    var controls = Array.from(dialog.querySelectorAll('button'));
    var first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
})();
